import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyB8VeTeBq-8V5h6Q5k66BaWP2kE844RoXw",
  authDomain: "nus-bins.firebaseapp.com",
  projectId: "nus-bins",
  storageBucket: "nus-bins.appspot.com",
  messagingSenderId: "655732525507",
  appId: "1:655732525507:web:c36049f5bd80f265595576"
};


  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  export const auth = getAuth(app);
  export default app;